import React, { useCallback, useEffect, useMemo, useState } from 'react';
import s from './styles.module.css';
import initial from '../../assets/aman-horse.png';
import { useNavigate } from 'react-router-dom';
import {
    AddProductsIcon,
    Analytics1688Icon,
    CityAnalyticsIcon,
    CreatedBayerIcon,
    CubeIcons,
    DeletedCargoIcon,
    DeletedUsersIcon,
    FaceIcons,
    LogoutIcon,
    LostItemsIcon,
    MarkerIcon,
    ProductsReportIcon,
    QuestionsIcons,
    StatusChKzIcon,
    TarifIcons,
    TrafficsIcon,
} from '../../icons';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import { TurkeyIconPlane } from '../../icons/info-page-icons/TurkeyIconPlane';
import { ChinaIconPlane } from '../../icons/info-page-icons/ChinaIconPlane';
import { useSearchInputStore } from '../../store/search-input-store/search-input-store';

/* ────────────────────────── helpers ────────────────────────── */

const getUserRole = (role) => {
    switch (role) {
        case 'RoleLeadAdmin':
            return `Роль: Лид Админ`;
        case 'RoleAlmaty':
            return 'Роль: Админ';
        case 'RoleAdminKg':
            return 'Роль: Админ KG';
        case 'RoleLeadAdminKg':
            return `Роль: Лид Админ KG`;
        case 'RoleBishkek':
            return 'Роль: Бишкек';
        case 'RoleUchet':
            return 'Роль: Учет';
        case 'RoleTurkey':
            return 'Роль: Турция';
        case 'RoleChina':
            return 'Роль: Китай';
        case 'RoleAdmin':
            return 'Роль: Админ';
    }
};

const UserInfo = ({ translation, role, phoneNumber }) => (
    <div className={s['content-info']}>
        <div className={s['content-div']}>
            <img className={s['content-img']} src={initial} alt="initial" />
            <p
                className={s['content-group']}
                style={{ display: 'flex', flexDirection: 'column', gap: 10 }}
            >
                <span>{getUserRole(role)}</span>
                {/*{(role === 'RoleLeadAdmin' || role === 'RoleLeadAdminKg') && (*/}
                    <span style={{ lineHeight: 1.3 }}>
                        {translation('phoneNumber')}: {phoneNumber}
                    </span>
                {/*)}*/}
            </p>
        </div>
    </div>
);

const LanguageSwitcher = ({
    language,
    changeToRussian,
    changeToKazakh,
    changeToChina,
    changeToKyrgyz,
}) => {
    const style = (code) => ({
        cursor: 'pointer',
        color: language === code ? 'rgba(16,14,113,1)' : 'rgba(177,179,182,1)',
    });
    return (
        <div className={s['div-change-language']}>
            <p style={style('ru')} onClick={changeToRussian} className={s['style-change-language']}>
                Рус
            </p>
            <span className={s['dot']} />
            <p style={style('kz')} onClick={changeToKazakh} className={s['style-change-language']}>
                Қаз
            </p>
            <span className={s['dot']} />
            <p style={style('kg')} onClick={changeToKyrgyz} className={s['style-change-language']}>
                Кырг
            </p>
            <span className={s['dot']} />
            <p style={style('ch')} onClick={changeToChina} className={s['style-change-language']}>
                中国
            </p>
        </div>
    );
};

const AdminKgLinks = ({
    handleLinkClick,
    activeLink,
    translation,
    language,
    changeToRussian,
    changeToKazakh,
    changeToChina,
    changeToKyrgyz,
    logout,
    role,
}) => {
    const setSearchingCode = useSearchInputStore((st) => st.setSearchingCode);
    const links = [
        {
            path: '/my-cargo',
            icon: <ChinaIconPlane styleSVG="style-cube-svg" />,
            text: translation('chinaCargos'),
        },
        {
            path: '/branches',
            icon: <MarkerIcon styleSVG="style-cube-svg" />,
            text: translation('branches'),
        },
        {
            path: '/my-customers',
            icon: <FaceIcons styleSVG="style-cube-svg" />,
            text: translation('users-admin'),
        },
        {
            path: '/rates',
            icon: <TarifIcons styleSVG="style-cube-svg" />,
            text: translation('rates'),
        },
        role === 'RoleLeadAdminKg' && {
            path: '/1688-delivery',
            icon: <Analytics1688Icon styleSVG="style-cube-svg" />,
            text: 'Доставки для 1688',
        },
    ];

    return (
        <div className={s['role-client']}>
            <div className={s['type']}>
                {links.filter(Boolean).map((l) => (
                    <div
                        key={l.path}
                        onClick={() => {
                            setSearchingCode('');
                            handleLinkClick(l.path);
                        }}
                        className={`${s['type-div']} ${activeLink === l.path ? s['active'] : ''}`}
                    >
                        {l.icon}
                        <p className={s['type-text']}>{l.text}</p>
                    </div>
                ))}
                <div className={s['line-2']} />
                <div className={s['settings']}>
                    <LanguageSwitcher
                        {...{
                            language,
                            changeToRussian,
                            changeToKazakh,
                            changeToChina,
                            changeToKyrgyz,
                        }}
                    />
                    <div className={s['logout-div']}>
                        <LogoutIcon styleSVG="logout__svg" />
                        <p onClick={logout} className={s['logout-text']}>
                            {translation('logout')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

/* ────────────────────────── Клиент ────────────────────────── */
const ClientLinks = ({
    handleLinkClick,
    activeLink,
    translation,
    language,
    changeToRussian,
    changeToKazakh,
    changeToChina,
    changeToKyrgyz,
}) => {
    const setSearchingCode = useSearchInputStore((st) => st.setSearchingCode);
    const links = [
        {
            path: '/client-main',
            icon: <CubeIcons styleSVG="style-cube-svg" />,
            text: translation('mainPage'),
        },
        {
            path: '/my-orders',
            icon: <ChinaIconPlane styleSVG="style-cube-svg" />,
            text: translation('ordersFromChina'),
        },
        {
            path: '/my-orders-turkey',
            icon: <TurkeyIconPlane styleSVG="style-cube-svg" />,
            text: translation('ordersFromTurkey'),
        },
        {
            path: '/my-profile',
            icon: <FaceIcons styleSVG="style-cube-svg" />,
            text: translation('profile'),
        },
        {
            path: '/rates',
            icon: <TarifIcons styleSVG="style-cube-svg" />,
            text: translation('rates'),
        },
        {
            path: '/client-main/statuses',
            icon: <QuestionsIcons styleSVG="style-cube-svg" />,
            text: translation('questionHelper'),
        },
    ];

    return (
        <div className={s['role-client']}>
            <div className={s['type']}>
                {links.map((l) => (
                    <div
                        key={l.path}
                        onClick={() => {
                            setSearchingCode('');
                            handleLinkClick(l.path);
                        }}
                        className={`${s['type-div']} ${activeLink === l.path ? s['active'] : ''}`}
                    >
                        {l.icon}
                        <p className={s['type-text']}>{l.text}</p>
                    </div>
                ))}
                <div className={s['line-2']} />
                <LanguageSwitcher
                    {...{
                        language,
                        changeToRussian,
                        changeToKazakh,
                        changeToChina,
                        changeToKyrgyz,
                    }}
                />
            </div>
        </div>
    );
};

/* ─────────────────────────── Админ ─────────────────────────── */
const AdminLinks = ({
    handleLinkClick,
    activeLink,
    translation,
    language,
    changeToRussian,
    changeToKazakh,
    changeToChina,
    changeToKyrgyz,
    logout,
    role,
}) => {
    const { setSearchingCode } = useSearchInputStore();

    const blockAmanTrans = useMemo(
        () =>
            [
                {
                    path: '/admin-main',
                    icon: <TarifIcons styleSVG="style-cube-svg" />,
                    text: translation('static'),
                },
                role !== 'RoleTurkey' && {
                    path: '/my-cargo',
                    icon: <ChinaIconPlane styleSVG="style-cube-svg" />,
                    text: translation('chinaCargos'),
                },
                {
                    path: '/turkey-cargo',
                    icon: <TurkeyIconPlane styleSVG="style-cube-svg" />,
                    text: translation('turkeyCargos'),
                },
                {
                    path: '/my-customers',
                    icon: <FaceIcons styleSVG="style-cube-svg" />,
                    text: translation('users-admin'),
                },
                role !== 'RoleTurkey' && {
                    path: '/branches',
                    icon: <MarkerIcon styleSVG="style-cube-svg" />,
                    text: translation('branches'),
                },
                role !== 'RoleTurkey' && {
                    path: '/deleted-users',
                    icon: <DeletedUsersIcon styleSVG="style-cube-svg" />,
                    text: translation('deletedUsers'),
                },
                role !== 'RoleTurkey' && {
                    path: '/deleted-cargo',
                    icon: <DeletedCargoIcon styleSVG="style-cube-svg" />,
                    text: translation('deletedCargo'),
                },
                {
                    path: '/rates',
                    icon: <TrafficsIcon styleSVG="style-cube-svg" />,
                    text: translation('rates'),
                },
                role !== 'RoleTurkey' && {
                    path: '/lost-items',
                    icon: <LostItemsIcon styleSVG="style-cube-svg" />,
                    text: translation('lostItems'),
                },
                ['RoleLeadAdmin', 'RoleAlmaty'].includes(role) && {
                    path: '/clients-without-whatsapp',
                    icon: <LostItemsIcon styleSVG="style-cube-svg" />,
                    text: translation('clientsWithoutWhatsapp'),
                },
                role === 'RoleLeadAdmin' && {
                    path: '/create-buyer',
                    icon: <CreatedBayerIcon styleSVG="style-cube-svg" />,
                    text: translation('createBauer'),
                },
                role === 'RoleTurkey' && {
                    path: '/create-buyer',
                    icon: <CreatedBayerIcon styleSVG="style-cube-svg" />,
                    text: translation('createBauer'),
                },
                {
                    path: '/client-main/statuses',
                    icon: <QuestionsIcons styleSVG="style-cube-svg" />,
                    text: translation('questionHelper'),
                },
            ].filter(Boolean),
        [role, translation],
    );

    const block1688 = [
        // {
        //     path: '/status-ch-kz',
        //     icon: <StatusChKzIcon styleSVG="style-cube-svg" />,
        //     text: translation('sider.statusChinaKaz'),
        // },
        {
            path: '/prohibited-goods',
            icon: <FaceIcons styleSVG="style-cube-svg" />,
            text: translation('dangerProducts.title'),
        },
        {
            path: '/analytics-1688',
            icon: <Analytics1688Icon styleSVG="style-cube-svg" />,
            text: translation('sider.analytics1688'),
        },
        {
            path: '/city-analytics',
            icon: <CityAnalyticsIcon styleSVG="style-cube-svg" />,
            text: translation('sider.cityAnalytics'),
        },
        {
            path: '/add-products',
            icon: <AddProductsIcon styleSVG="style-cube-svg" />,
            text: translation('sider.productAddition'),
        },
        {
            path: '/product-report',
            icon: <ProductsReportIcon styleSVG="style-cube-svg" />,
            text: translation('sider.productReport'),
        },
        ['RoleLeadAdmin', 'RoleChina'].includes(role) && {
            path: '/1688-late-delivery',
            icon: <LostItemsIcon styleSVG="style-cube-svg" />,
            text: translation('delayedDeliveries'),
        },
        ['RoleLeadAdmin', 'RoleChina'].includes(role) && {
            path: '/1688-delivery',
            icon: <Analytics1688Icon styleSVG="style-cube-svg" />,
            text: translation('deliveriesFor1688'),
        },
        ['RoleLeadAdmin','RoleChina', 'RoleAlmaty'].includes(role) && {
            path: '/1688-order-info',
            icon: <StatusChKzIcon styleSVG="style-cube-svg" />,
            text: translation('getOrderInfo'),
        },
    ].filter(Boolean);

    const renderLink = (l) => (
        <div
            key={l.path}
            onClick={() => {
                setSearchingCode('');
                handleLinkClick(l.path);
            }}
            className={`${s['type-div']} ${activeLink === l.path ? s['active'] : ''}`}
        >
            {l.icon}
            <p className={s['type-text']}>{l.text}</p>
        </div>
    );

    return (
        <div className={s['role-admin']}>
            <div className={s['type__container']}>
                <div className={s['type__line']}>
                    <div className={s['type__title']}>Аман Транс</div>
                    <div className={s['type']}>{blockAmanTrans.map(renderLink)}</div>
                </div>
                {role !== 'RoleTurkey' ? (
                    <div className={s['type__line']}>
                        <div className={s['type__title']}>1688</div>

                        <div className={s['type']}>{block1688.map(renderLink)}</div>
                    </div>
                ) : (
                    ''
                )}
            </div>

            <div className={s['line-2']} />

            <div className={s['settings']}>
                <LanguageSwitcher
                    {...{
                        language,
                        changeToRussian,
                        changeToKazakh,
                        changeToChina,
                        changeToKyrgyz,
                    }}
                />
                <div className={s['logout-div']}>
                    <LogoutIcon styleSVG="logout__svg" />
                    <p onClick={logout} className={s['logout-text']}>
                        {translation('logout')}
                    </p>
                </div>
            </div>
        </div>
    );
};

/* ─────────────────────────── Учёт ─────────────────────────── */
const UchetLinks = ({
    handleLinkClick,
    activeLink,
    translation,
    language,
    changeToRussian,
    changeToKazakh,
    changeToChina,
    logout,
    changeToKyrgyz,
}) => (
    <div className={s['role-client']}>
        <div className={s['type']}>
            <div
                onClick={() => handleLinkClick('/report')}
                className={`${s['type-div']} ${activeLink === '/report' ? s['active'] : ''}`}
            >
                <TarifIcons styleSVG="style-cube-svg" />
                <p className={s['type-text']}>{translation('report')}</p>
            </div>
            <div className={s['line-2']} />
            <LanguageSwitcher
                {...{ language, changeToRussian, changeToKazakh, changeToChina, changeToKyrgyz }}
            />
            <div className={s['logout-div']}>
                <p onClick={logout} className={s['logout-text']}>
                    {translation('logout')}
                </p>
            </div>
        </div>
    </div>
);

/* ────────────────────────── Страница ───────────────────────── */
const InfoPage = ({
    closeMenu,
    translation,
    handleLenguageChange,
    language,
    changeToRussian,
    changeToKazakh,
    changeToChina,
    changeToKyrgyz,
}) => {
    const [role, setRole] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [activeLink, setActiveLink] = useState(localStorage.getItem('activeLink') || '');
    const navigate = useNavigate();

    /* decode token once */
    useEffect(() => {
        const token = Cookies.get('token');
        if (!token) {
            setRole('');
            setPhoneNumber('');
            return;
        }
        try {
            const { role, phone } = jwtDecode(token);
            setRole(role);
            setPhoneNumber(phone);
        } catch {
            setRole('');
            setPhoneNumber('');
        }
    }, []);

    useEffect(() => localStorage.setItem('activeLink', activeLink), [activeLink]);

    const handleLinkClick = useCallback(
        (path) => {
            setActiveLink(path);
            navigate(path);
            closeMenu?.();
        },
        [navigate, closeMenu],
    );

    const logout = useCallback(() => {
        Cookies.remove('token');
        navigate('/');
    }, [navigate]);

    if (role === null) return <div>Loading…</div>;

    const contentByRole = ['RoleAdminKg', 'RoleLeadAdminKg'].includes(role) ? (
        <AdminKgLinks
            {...{
                handleLinkClick,
                activeLink,
                translation,
                language,
                changeToRussian,
                changeToKazakh,
                changeToChina,
                changeToKyrgyz,
                logout,
                role,
            }}
        />
    ) : role === 'RoleUchet' ? (
        <UchetLinks
            {...{
                handleLinkClick,
                activeLink,
                translation,
                language,
                changeToRussian,
                changeToKazakh,
                changeToChina,
                changeToKyrgyz,
                logout,
            }}
        />
    ) : [
          'RoleAdmin',
          'RoleLeadAdmin',
          'RoleAlmaty',
          'RoleChina',
          'RoleTurkey',
          'RoleBishkek',
      ].includes(role) ? (
        <AdminLinks
            {...{
                handleLinkClick,
                activeLink,
                translation,
                language,
                changeToRussian,
                changeToKazakh,
                changeToChina,
                changeToKyrgyz,
                logout,
                role,
            }}
        />
    ) : (
        <ClientLinks
            {...{
                handleLinkClick,
                activeLink,
                translation,
                language,
                changeToRussian,
                changeToKazakh,
                changeToChina,
                changeToKyrgyz,
            }}
        />
    );

    return (
        <div className={s['container']}>
            <UserInfo translation={translation} role={role} phoneNumber={phoneNumber} />
            {contentByRole}
        </div>
    );
};

export default InfoPage;
